import React from 'react';
import { CTAButton } from './CTAButton';
import { comoFunciona } from '../data/content';
export function Solution() {
  return <section className="w-full bg-ink-black" aria-labelledby="solucion-titulo" data-id="element-173" data-mp="1ejavyoq9aoa0">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-6 sm:py-16" data-id="element-174" data-mp="10s4n42137eag">
        <div className="mx-auto max-w-3xl text-center" data-id="element-175" data-mp="15s0r419sb5q0">
          <h2 id="solucion-titulo" className="font-display text-[1.6rem] leading-[1.05] text-white sm:text-4xl" data-id="element-176" data-mp="15qfwycrdtoso">
            Anfitrión Pro 365™ es el{' '}
            <span className="text-brand" data-id="element-177" data-mp="vvo0jc9jd7zh">Método de Arquitectura Operativa</span>{' '}
            para tu Airbnb
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-178" data-mp="hwegu2m4fvqr">
            Esto no es teoría vacía. Es un sistema de aprendizaje técnico e
            implementación inmediata. Vas a dominar la biblioteca completa de
            manuales, checklists y protocolos que te enseñan a estandarizar tu
            gestión y transformar tu propiedad en un negocio real que no dependa
            de tu improvisación.
          </p>
        </div>

        <ol className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-179" data-mp="2y3ybr6tbbjh">
          {comoFunciona.map((paso, index) => <li key={paso.titulo} className="rounded-xl border border-white/10 bg-white/[0.04] p-4" data-id="element-180" data-mp="gso4h7psg4jm" data-mpi={index}>
              <span className="font-display text-3xl leading-none text-brand" data-id="element-181" data-mp="3k6qvo7w8nugi">
                0{index + 1}
              </span>
              <h3 className="font-display mt-3 text-lg leading-tight text-white" data-id="element-182" data-mp="3g706u9q9voem">
                {paso.titulo}
              </h3>
              <p className="mt-1.5 text-[13px] leading-relaxed text-white/60" data-id="element-183" data-mp="3u3dekr508bfw">
                {paso.detalle}
              </p>
            </li>)}
        </ol>

        <div className="mx-auto mt-8 max-w-sm" data-id="element-184" data-mp="19dxq42t9cytf">
          <CTAButton label="Quiero dominar el método" size="lg" fullWidth data-id="element-185" data-mp="14g4n1in94kxd" />
          <p className="mt-2.5 text-center text-[11px] font-semibold text-white/50" data-id="element-186" data-mp="14i8nfqlxz1sw">
            Acceso inmediato · Pago único · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}